module.exports = __webpack_public_path__ + "static/media/phone-app.ce12779b.png";